import React from 'react';

import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <path d="M12.403.19c-6.628 0-12 4.327-12 9.665 0 2.17.9 4.168 2.4 5.78v4.354a1.2 1.2 0 001.74 1.072l4.06-2.044a14.63 14.63 0 003.8.503c6.627 0 12-4.328 12-9.665 0-5.338-5.373-9.666-12-9.666z" />,
  'Chatroom',
  { viewBox: '0 0 24 22' },
);
